@if (relatedServiceSuggestions?.length > 0) {
  @for (suggestion of relatedServiceSuggestions; track suggestion.relatedService.id) {
    @if (!suggestion.isAddedToCart) {
      <div class="cbsw-related-service-suggestion" [@expandCollapse]>
        <div class="cbsw-related-service-row">
          <div
            class="cbsw-related-service-text"
            [innerHTML]="suggestion.combinedBookingText | calioSafe: 'html'"
          ></div>
          <div class="cbsw-related-service-slots">
            @for (slot of suggestion.availableSlots; track $index) {
              <div class="cbsw-related-service-slot-row">
                <span class="cbsw-related-service-slot-time">
                  {{ slot.start | dateutc: 'DD.MM.y,' }} {{ slot.start | dateutc: timeFormat }} - {{ slot.end | dateutc: timeFormat }}
                  ({{ slot.worker?.resource_name }})
                </span>
                (<a
                  href="javascript:void(0)"
                  class="cbsw-related-service-add-link"
                  [style.color]="widgetService?.widgetConf?.button_background_color"
                  (click)="onSelectSlot(suggestion, slot)"
                >{{ 'booking_components.add' | translate }}</a>)
              </div>
            }
          </div>
        </div>
      </div>
    }
  }
}
